export default __webpack_public_path__ + "static/media/footer-banner.d4e7d04b.jpg";